import React from "react";
import styles from "./Testimonials.module.css";
import Image from "next/image";

interface Image {
  id: number;
  documentId: string;
  url: string;
  alternativeText: string;
}

interface TileDescription {
  id: number;
  title: string;
  description: string;
}

interface CardWithImage {
  id: number;
  title_description: TileDescription;
  images: Image[];
}

interface TestimonialCard {
  id: number;
  posted_at: string;
  rating_number: number;
  card_with_image: CardWithImage;
}

interface TestimonialsData {
  id: number;
  title: string;
  testimonial_cards: TestimonialCard[];
}

interface TestimonialsProps {
  data: TestimonialsData;
}

const renderStars = (rating: number) => {
  const fullStars = Math.floor(rating);
  const hasHalfStar = rating % 1 !== 0;
  const totalStars = 5;

  return Array(totalStars)
    .fill(0)
    .map((_, i) => {
      if (i < fullStars) {
        return (
          <span key={i} className={styles.starFilled}>
            <Image
              src="/assets/star-solid.svg"
              width={20}
              height={20}
              alt="starFilled"
              title="starFilled"
            ></Image>
          </span>
        );
      } else if (hasHalfStar && i === fullStars) {
        return (
          <span key={i} className={styles.starFilled}>
            <Image
              src="/assets/star-half-stroke-solid.svg"
              width={20}
              height={20}
              alt={"starFilled"}
              title={"starFilled"}
            ></Image>
          </span>
        );
      } else {
        return (
          <span key={i} className={styles.starFilled}>
            <Image
              src="/assets/star-regular.svg"
              width={20}
              height={20}
              alt="starFilled"
              title="starFilled"
            ></Image>
          </span>
        );
      }
    });
};

const formatDate = (dateString: string): string => {
  const date = new Date(dateString);
  return date.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
};

const Testimonials: React.FC<TestimonialsProps> = ({ data }) => {
  const testimonials = data?.testimonial_cards || [];
  const cutOffDate = new Date("1999-01-01").setHours(0, 0, 0, 0);

  return (
    <div className={styles.testimonialsSection}>
      <h2>{data?.title}</h2>

      <div className={styles.testimonialsContainer}>
        {testimonials.map((testimonial) => {
          const postedDate = new Date(testimonial?.posted_at).setHours(
            0,
            0,
            0,
            0
          );

          const isValidDate = postedDate >= cutOffDate;

          return (
            <div key={testimonial?.id} className={styles.testimonialCard}>
              <div className={styles.stars}>
                {renderStars(testimonial?.rating_number)}
              </div>
              <p className={styles.testimonialContent}>
                {testimonial?.card_with_image?.title_description?.description}
              </p>
              <div className={styles.testimonialFooter}>
                <div className={styles.avatar}>
                  <Image
                    src={testimonial?.card_with_image?.images[0]?.url}
                    alt={
                      testimonial?.card_with_image?.images[0]
                        ?.alternativeText || "Testimonial"
                    }
                    title={
                      testimonial?.card_with_image?.images[0]
                        ?.alternativeText || "Testimonial"
                    }
                    width={40}
                    height={40}
                  />
                </div>
                <div className={styles.contant}>
                  <h3>
                    {testimonial?.card_with_image?.title_description?.title}
                  </h3>

                  {isValidDate && <p>{formatDate(testimonial?.posted_at)}</p>}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Testimonials;
